const EXCHANGE_NAMES = {
  EN: {
    ALLX: "All Stock Exchanges",
    XBUL: "Bulgarian Stock Exchange",
    XETR: "Deutsche Börse Xetra",
    XFRA: "Deutsche Börse Frankfurt"
  },
  BG: {
    ALLX: "Всички фондови борси",
    XBUL: "Българска фондова борса",
    XETR: "Deutsche Börse Xetra",
    XFRA: "Deutsche Börse Frankfurt"
  }
};

function normalizeLanguage(language) {
  return "BG" === language?.toString().toUpperCase() ? "BG" : "EN";
}

function getExchangeCode(exchangeOrCode) {
  if ("string" === typeof exchangeOrCode || "number" === typeof exchangeOrCode) {
    return exchangeOrCode.toString().toUpperCase();
  }

  return exchangeOrCode?.code?.toString().toUpperCase() || "";
}

const EXCHANGE_DISPLAY_ORDER = ["XBUL", "XETR", "XFRA"];

export function sortExchanges(exchanges) {
  return [...(exchanges || [])].sort((a, b) => {
    const aPosition = EXCHANGE_DISPLAY_ORDER.indexOf(getExchangeCode(a));
    const bPosition = EXCHANGE_DISPLAY_ORDER.indexOf(getExchangeCode(b));
    const normalizedAPosition = -1 === aPosition ? EXCHANGE_DISPLAY_ORDER.length : aPosition;
    const normalizedBPosition = -1 === bPosition ? EXCHANGE_DISPLAY_ORDER.length : bPosition;

    return normalizedAPosition - normalizedBPosition;
  });
}

export function getAllExchangesSelectLabel(language) {
  const names = EXCHANGE_NAMES[normalizeLanguage(language)];
  return `ALLX - ${names.ALLX}`;
}

export function getExchangeDisplayName(exchangeOrCode, language) {
  const code = getExchangeCode(exchangeOrCode);
  const names = EXCHANGE_NAMES[normalizeLanguage(language)];
  const localizedName = names[code];

  if (localizedName) {
    return localizedName;
  }

  if ("object" === typeof exchangeOrCode && exchangeOrCode) {
    return exchangeOrCode.nEN || exchangeOrCode.name || "";
  }

  return "";
}

export function getExchangeSelectLabel(exchangeOrCode, language) {
  const code = getExchangeCode(exchangeOrCode);
  const name = getExchangeDisplayName(exchangeOrCode, language);

  return name ? `${code} - ${name}` : code;
}
